import api from "../../http";
import cookie from "js-cookie";

export default class ApiContactsMail {
  static async postApiContactsMail(url, data) {
    return api.post(url, data, {
      headers: {
        "X-CSRFToken": cookie.get('csrftoken') || ''
      }
    })
  }
}